import type { ComponentPropsWithRef } from 'react'
import { cn } from '../../lib/cn'
import s from './Eyebrow.module.css'

/**
 * L'`.eyebrow` des prototypes. Un `<span>` rendu en bloc : il se pose dans un `<label>`, un
 * `<button>` ou un titre sans casser leur modèle de contenu.
 */
export function Eyebrow({ className, ...props }: ComponentPropsWithRef<'span'>) {
  return <span className={cn(s.root, className)} {...props} />
}
